import { Link } from "react-router-dom";
import { categoryEntries } from "@/mocks/movies";

export default function CategoryQuick() {
  return (
    <div className="rounded-lg border border-background-200 bg-white p-5">
      <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
        <span className="flex h-6 w-6 items-center justify-center rounded-md bg-primary-100 text-primary-600">
          <i className="ri-layout-grid-line text-sm"></i>
        </span>
        分类快捷入口
      </h2>
      <div className="mt-4 grid grid-cols-2 gap-3">
        {categoryEntries.map((item) => (
          <Link
            key={item.key}
            to={`/category/${item.key}`}
            className="group relative h-32 overflow-hidden rounded-lg"
          >
            <img
              src={item.image}
              alt={`${item.name}分类封面`}
              title={`${item.name} - 恋爱的味道分类频道`}
              className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/75 to-foreground-950/15"></div>
            <div className="absolute inset-x-0 bottom-0 p-3">
              <p className="font-heading text-sm font-bold text-white">{item.name}</p>
              <p className="mt-0.5 text-[11px] text-white/80">进入{item.name}频道</p>
            </div>
          </Link>
        ))}
      </div>
      <p className="mt-3 text-xs leading-relaxed text-foreground-600">
        都市情感、青春校园、古装情缘与海外佳剧，一网打尽。
      </p>
    </div>
  );
}